import React, { useState } from 'react';
import { Plus, Trash2, Ticket, Star, Layers } from 'lucide-react';

export default function Dashboard({ parlays, setParlays, isAdmin }) {
  // States for new parlay formulation inside admin mode
  const [newTitle, setNewTitle] = useState('');
  const [newSport, setNewSport] = useState('MLB');
  const [newRisk, setNewRisk] = useState('S-Tier');
  const [newOdds, setNewOdds] = useState('+100');
  
  // States for dynamic construction of unique internal legs
  const [legs, setLegs] = useState([{ team: '', market: '', odds: '' }]);

  const handleAddLegField = () => {
    setLegs([...legs, { team: '', market: '', odds: '' }]);
  };

  const handleLegChange = (index, field, value) => {
    const updatedLegs = [...legs];
    updatedLegs[index][field] = value;
    setLegs(updatedLegs);
  };

  const handleCreateParlay = (e) => {
    e.preventDefault();
    if (!newTitle) return;

    const newSlip = {
      id: Date.now(),
      title: newTitle,
      sport: newSport,
      risk: newRisk,
      legs: legs.filter(l => l.team !== ''),
      totalOdds: newOdds,
      status: "Active"
    };

    setParlays([newSlip, ...parlays]);
    // Reset inputs
    setNewTitle('');
    setNewOdds('+100');
    setLegs([{ team: '', market: '', odds: '' }]);
  };

  const handleDeleteParlay = (id) => {
    setParlays(parlays.filter(p => p.id !== id));
  };

  return (
    <div style={{ padding: '3rem 5%', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem' }}>
        <div>
          <h2 className="font-display" style={{ fontSize: '2rem' }}>CURRENT <span style={{ color: '#A3FF12' }}>BOARD</span></h2>
          <p style={{ color: '#8E9A88', fontSize: '0.95rem' }}>Live tracked active card selections.</p>
        </div>
        {isAdmin && <span style={{ backgroundColor: '#A3FF12', color: '#080B07', padding: '0.3rem 0.8rem', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 700 }}>ADMIN CONTROL MODE</span>}
      </div>

      {/* Admin Operations Section */}
      {isAdmin && (
        <div style={{ backgroundColor: '#11160F', border: '1px solid #A3FF12', padding: '2rem', borderRadius: '8px', marginBottom: '3rem' }}>
          <h3 className="font-display" style={{ marginBottom: '1.5rem', fontSize: '1.2rem', color: '#A3FF12', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Plus size={18} /> Post Dynamic Parlay Slip
          </h3>
          <form onSubmit={handleCreateParlay}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: '#8E9A88', marginBottom: '0.3rem' }}>Slip Title</label>
                <input type="text" value={newTitle} onChange={e => setNewTitle(e.target.value)} placeholder="e.g. Sharp Unit Lock" style={{ width: '100%', backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.6rem', borderRadius: '4px' }} className="glow-border" />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: '#8E9A88', marginBottom: '0.3rem' }}>Sport Market</label>
                <select value={newSport} onChange={e => setNewSport(e.target.value)} style={{ width: '100%', backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.6rem', borderRadius: '4px' }}>
                  <option value="MLB">MLB</option>
                  <option value="ESPORTS">ESPORTS</option>
                  <option value="NBA">NBA</option>
                  <option value="NHL">NHL</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: '#8E9A88', marginBottom: '0.3rem' }}>Confidence Rank</label>
                <select value={newRisk} onChange={e => setNewRisk(e.target.value)} style={{ width: '100%', backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.6rem', borderRadius: '4px' }}>
                  <option value="S-Tier">S-Tier (Max Confidence)</option>
                  <option value="A-Tier">A-Tier (High EV)</option>
                  <option value="B-Tier">B-Tier (Standard Play)</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: '#8E9A88', marginBottom: '0.3rem' }}>Total Combined Odds</label>
                <input type="text" value={newOdds} onChange={e => setNewOdds(e.target.value)} placeholder="+100" style={{ width: '100%', backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.6rem', borderRadius: '4px' }} className="glow-border" />
              </div>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <span style={{ display: 'block', fontSize: '0.8rem', color: '#8E9A88', marginBottom: '0.5rem' }}>Parlay Selection Legs</span>
              {legs.map((leg, idx) => (
                <div key={idx} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <input type="text" placeholder="Matchup / Teams" value={leg.team} onChange={e => handleLegChange(idx, 'team', e.target.value)} style={{ flex: 2, backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.5rem', borderRadius: '4px' }} />
                  <input type="text" placeholder="Specific Bet Line" value={leg.market} onChange={e => handleLegChange(idx, 'market', e.target.value)} style={{ flex: 2, backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.5rem', borderRadius: '4px' }} />
                  <input type="text" placeholder="Odds" value={leg.odds} onChange={e => handleLegChange(idx, 'odds', e.target.value)} style={{ flex: 1, backgroundColor: '#080B07', border: '1px solid #1B2318', color: '#fff', padding: '0.5rem', borderRadius: '4px' }} />
                </div>
              ))}
              <button type="button" onClick={handleAddLegField} style={{ background: 'none', border: 'none', color: '#A3FF12', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem', marginTop: '0.5rem' }}>
                + Add Another Leg Split
              </button>
            </div>

            <button type="submit" style={{ backgroundColor: '#A3FF12', color: '#080B07', fontWeight: 700, padding: '0.6rem 1.5rem', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
              Publish Slip to Board
            </button>
          </form>
        </div>
      )}

      {/* Main Parlays Display Tracker */}
      {parlays.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '4rem', border: '1px dashed #1B2318', color: '#8E9A88', borderRadius: '8px' }}>
          No active betting slips posted on board. Check back closer to lock times.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '2rem' }}>
          {parlays.map((parlay) => (
            <div key={parlay.id} style={{ backgroundColor: '#11160F', border: '1px solid #1B2318', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              {/* Card Header Banner Wrapper */}
              <div style={{ backgroundColor: '#161D13', padding: '1rem', borderBottom: '1px solid #1B2318', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontSize: '0.75rem', fontWeight: 700, backgroundColor: '#080B07', color: '#A3FF12', padding: '0.2rem 0.5rem', borderRadius: '3px', border: '1px solid #1B2318' }}>
                    {parlay.sport}
                  </span>
                  <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#fff', display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
                    <Star size={12} color="#A3FF12" fill="#A3FF12" /> {parlay.risk}
                  </span>
                </div>
                {isAdmin && (
                  <button onClick={() => handleDeleteParlay(parlay.id)} style={{ backgroundColor: 'transparent', border: 'none', color: '#ff4a4a', cursor: 'pointer' }}>
                    <Trash2 size={16} />
                  </button>
                )}
              </div>

              {/* Card Main Body Content */}
              <div style={{ padding: '1.25rem', flexGrow: 1 }}>
                <h4 className="font-display" style={{ fontSize: '1.1rem', marginBottom: '1rem', color: '#fff' }}>{parlay.title}</h4>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.25rem' }}>
                  {parlay.legs.map((leg, index) => (
                    <div key={index} style={{ paddingLeft: '0.75rem', borderLeft: '2px solid #A3FF12' }}>
                      <p style={{ fontSize: '0.8rem', color: '#8E9A88', fontWeight: 500 }}>{leg.team}</p>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.15rem' }}>
                        <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#fff' }}>{leg.market}</span>
                        <span style={{ fontSize: '0.9rem', color: '#A3FF12', fontWeight: 700 }}>{leg.odds}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Card Footer Total Combined Value Banner */}
              <div style={{ padding: '1rem', backgroundColor: '#0E130C', borderTop: '1px solid #1B2318', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.8rem', color: '#8E9A88', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                  <Ticket size={14} /> COMBINED ODDS
                </span>
                <span className="font-display" style={{ fontSize: '1.25rem', color: '#A3FF12', fontWeight: 900, textShadow: '0 0 8px rgba(163,255,12,0.2)' }}>
                  {parlay.totalOdds}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}